export default __webpack_public_path__ + "static/media/help-metis.bdda527d.svg";